import {useDispatch, useSelector} from "react-redux";
import {condition} from "../../../res/rest/restRequest";
import {getActiveDeliveries, getOrderLines, getOrders} from "../../../redux/action/accountActions";
import {idempiereDate} from "../../../res/dataServices/idempiereDate";
import {accountService} from "../../../res/dataServices/account";
import {idempiereType} from "../../../res/dataServices/idempiereType";
import {useState} from "react";

const useOrders = () => {

    const dispatch = useDispatch();

    const { session } = useSelector(
        state => state.auth
    )
    const { loading, error, ordering, activeShipments } = useSelector(
        state => state.account
    )
    const [fetchedDates, setFetchedDates] = useState({});

    const getAnOrder = (id) => {
        dispatch(getOrders({session, conditions: [condition.eq("c_order_id", id)]}))
    }

    const getAnOrdersLines = (id) => {
        dispatch(getOrderLines({session, orderID: id}));
    }

    const getOrdersByDate = (startDate, endDate, limit) => {
        const conditions = [
            condition.greaterThan("created", startDate),
            condition.lessOrEqual("created", endDate)
        ];
        dispatch(getOrders({session, conditions, limit}))
        setFetchedDates({startDate, endDate});
    }

    const getActiveShipments = () => {
        dispatch(getActiveDeliveries({session, includeProducts: true}))
    }

    const getOrderLinks = (order, ordering) => {
        const links = {};

        console.log(order.orderinvoices);

        const getLinkList = (itemIDs, items) => {
            const list = [];
            if(itemIDs) {
                const idSet = new Set(idempiereType.parseArray(itemIDs));
                for(const id of idSet) {
                    const item = items[id];
                    if(item) list.push(item);
                }
            }
            return list;
        }

        const invoices = getLinkList(order.orderinvoices, ordering.invoices);
        if(invoices.length > 0) links.invoices = invoices;

        const shipments = getLinkList(order.ordershipments, ordering.shipments);
        if(shipments.length > 0) links.shipments = shipments;

        return links;
    }

    if(!activeShipments && !loading.activeShipments && !error.activeShipments) {
        dispatch(getActiveDeliveries({session}));
    }

    const getOrderList = (ordering) => {
        if(!ordering.orders) return [];

        const orderList = Object.values(ordering.orders);
        orderList.sort((b,a) => idempiereDate.compareDates(a.DateOrdered, b.DateOrdered));
        return orderList;
    }

    const orders = getOrderList(ordering);
    const deliveryList = activeShipments ? activeShipments.shipments : [];
    const orderInfo = accountService.buildOrderDetail(orders, deliveryList);

    return {
        orders,
        ordering,
        deliveryList,
        orderInfo,
        fetchedDates,
        loading,
        error,
        getAnOrder,
        getOrdersByDate,
        getOrderLinks,
        getAnOrdersLines,
        getActiveShipments
    }

}

export default useOrders;
